// @flow
import * as actionTypes from '../constants/action_types'
import { windowStates } from '../components/window_state'
import type { WindowStateType } from '../components/window_state'

export type TabbedPanelType = {
    tabindex: number,
    windowState: WindowStateType,
}

type ActionType = {
    tabindex?: number,
    windowState?: WindowStateType
}

const initialState = {
    tabindex: 0,
    windowState: windowStates.minimized,
}

export default function tabbedPanel(state: TabbedPanelType = initialState, action: ActionType) {
    let ret = state
    if (action.type === actionTypes.LOG_SET || action.type === actionTypes.LOG_APPEND) {
        ret = {
            ...state,
            windowState: state.windowState === windowStates.minimized ? windowStates.opened : state.windowState,
        }
    } else if (action.type === actionTypes.TABBED_PANEL_INDEX) {
        ret = { ...state, tabindex: action.tabindex }
    } else if (action.type === actionTypes.TABBED_PANEL_WINDOW_STATE) {
        ret = { ...state, windowState: action.windowState }
    }

    return ret
}
